import { useAuthUser } from "../../../hooks/useAuthUser";
import { getShippingAddress } from "../../../utils/getShippingAddress";
import { DeliveryMethod } from "../../../utils/types";

type DeliveryMethodNoticeProps = {
  deliveryMethod: DeliveryMethod;
};

const shippingMessage = "Delivery to: ";
const pickupMessage = "Pickup at: ";

export const DeliveryMethodNotice = ({
  deliveryMethod,
}: DeliveryMethodNoticeProps) => {
  const { details } = useAuthUser();
  const message =
    deliveryMethod === DeliveryMethod.Shipping
      ? shippingMessage
      : pickupMessage;
  const boldedText =
    deliveryMethod === DeliveryMethod.Shipping
      ? getShippingAddress(details)
      : "Alnarp's Farm.";

  return (
    <p>
      {message}
      <span className="bold">{boldedText}</span>
    </p>
  );
};
